<template>
    <div class="touch-page">
        <div class="touch-header">
            <div class="touch-title"></div>
            <actouch-form class="touch-form"></actouch-form>
        </div>
        <div class="touch-whyvip"></div>
        <div class="touch-partone"></div>
        <div class="touch-parttwo"></div>
        <div class="touch-three">
            <v-swiper
                ref="swipe"
                class="touch-teachers-swipe"
                :options="swiperOptions"
            >
                <v-swiperslide>
                    <div class="teacher-fu"></div>
                </v-swiperslide>
                <v-swiperslide>
                    <div class="teacher-bai"></div>
                </v-swiperslide>
                <v-swiperslide>
                    <div class="teacher-fei"></div>
                </v-swiperslide>
                <v-swiperslide>
                    <div class="teacher-xian"></div>
                </v-swiperslide>
                <v-swiperslide>
                    <div class="teacher-yue"></div>
                </v-swiperslide>
            </v-swiper>
        </div>
        <div class="touch-partfour"></div>
        <div class="touch-partfive"></div>
        <div ref="videobox" class="touch-video" @click="switchStatus">
            <!-- <video src="https://www.w3school.com.cn/i/movie.ogg" poster=""> -->
            <video
                ref="video"
                :style="`visibility:${isplay ? 'visible' : 'hidden'}`"
                src="https://img.vipkidstatic.com/ec-edu/math/customer/referral/%E6%95%B0%E5%AD%A6%E6%80%9D%E7%BB%B4-%E8%AF%BE%E4%B8%AD%E4%BA%AE%E7%82%B9%E9%9B%86%E9%94%A6%E8%A7%86%E9%A2%91.mp4"
                :poster="poster"
                line
                preload="auto"
                playsinline
                x5-playsinline
                x-webkit-airplay="true"
                webkit-playsinline="true"
                x5-video-player-type="h5"
                x5-video-player-fullscreen=""
                x5-video-orientation="portraint"
                @pause="videoPause"
                @play="videoPlay"
            >
                your browser does not support the video tag
            </video>
            <div v-show="!isplay" class="touch-v-bt">
                <img :src="poster" />
                <div class="touch-bt"></div>
            </div>
        </div>
        <div class="touch-serve"></div>
        <div class="touch-qa"></div>
        <div class="touch-footer" v-if="$route.query.from !== 'huawei'">
            <div class="touch-footer-c" v-show="showbottom">
                <div class="touch-footer-info">
                    <div class="touch-footer-bit">
                        <div class="touch-footer-bitmap"></div>
                    </div>
                    <div class="touch-footer-content">
                        <p class="touch-footer-get">限时领取</p>
                        <p class="touch-footer-gift">
                            <span>398元</span>名师体验课
                        </p>
                    </div>
                    <div @click="toTop" class="touch-footer-bt">免费领取</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import jssdk, { wx } from '@/mixins/jssdk'
import cookie from 'js-cookie'
import gateway from '@/_gateway.config'
import { sendSmsCode, loginByCode, drainageSignUp } from '@/api/common'
import {
    updateStudentInfo,
    getStudentList,
    getStudentInfo
} from '@/api/account'
import {
    getReferrer,
    recordActivation,
    recordStudentActivation
} from '@/api/landingpage'
import '@/utils/gt'
import sasdk from './sasdkinit'
import { isPhone } from '@/utils/vilidate'
import { Toast } from 'vant'
import { APPID, CHANNELID, ACTIVITYCODE } from '@/config/actouch.js'
import poster from '@/assets/img/actouch/poster.png'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper.scss'
import ActouchForm from '@/components/actouch/form/index.vue'

// 多业务登录注册
// const appId = process.env.VUE_APP_ENV === 'production' ? 'gh_1343a1dcee8e' : '10034'
var timemeter
var appId = APPID
var channelKeyword = ACTIVITYCODE
var channelId = CHANNELID
var activityCode
var winh = document.documentElement.getBoundingClientRect().height
var winw = document.documentElement.getBoundingClientRect().width
var videotop = 0
var videoheight = 0
var initw = winw / 750
var hasplay = false
var viewtime
var scrolltopmax
export default {
    components: {
        ActouchForm,
        'v-swiper': Swiper,
        'v-swiperslide': SwiperSlide
    },
    data () {
        return {
            // 显示底部领取按钮
            showbottom: false,
            poster,
            // teacherwidth: 0,
            // 播放状态
            isplay: false,
            swiperOptions: {
                autoplay: true,
                loop: true,
                loopedSlides: 3,
                slidesPerView: 'auto',
                slidesOffsetBefore: initw * 32
            },
            fixvideo: false,
            // 枚举数字图片名称
            // nums: ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
            displaySelectStudent: false,
            studentList: []
        }
    },
    created () {
        // if (this.$route.query.appId) {
        //     appId = this.$route.query.appId
        // }
        // if (this.$route.query.channelKeyword) {
        //     channelKeyword = this.$route.query.channelKeyword
        // }
        // if (this.$route.query.channelId) {
        //     channelId = this.$route.query.channelId
        // }
        // if (this.$route.query.activityCode) {
        //     activityCode = this.$route.query.activityCode
        // }
        // const parentId = this.getParentID()
        // const Authorization = cookie.get('Authorization')
        // sasdk.registerPage({
        //     channel_id: channelId
        // })
        // if (parentId && Authorization) {
        //     this.drainageSignUp()
        //     getReferrer({
        //         parentId: parentId
        //     }).then(res => {
        //         if (res.code === 200) {
        //             this.userinfo = res.data
        //             this.inputphone = res.data.mobile
        //         }
        //     })
        //     // 神策埋点 userid
        //     cookie.set('cookie_id', parentId)
        // }
        window.addEventListener('scroll', e => {
            this.onPageScroll(e)
        })
        // var initw = window.innerWidth / 750
        // this.teacherwidth = initw * 340
        viewtime = new Date().getTime()
        scrolltopmax = 0
    },
    beforeDestroy () {
        var time = new Date().getTime()
        sasdk.leavepage(time - viewtime, scrolltopmax / initw)
    },
    mounted () {
        sasdk.viewindex()
        videotop = this.$refs.videobox.offsetTop
        videoheight = this.$refs.videobox.clientHeight
    },
    methods: {
        // onjssdkready () {
        //   wx.hideMenuItems({
        //     menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:QZone'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        //   })
        // },
        getParentID () {
            return (
                cookie.get('mathparentid') || cookie.get('mbparentid') || null
            )
        },
        getReferrer (callback) {
            const parentId = this.getParentID()
            getReferrer({
                parentId: parentId
            })
                .then(res => {
                    if (res.code === 200) {
                        this.userinfo = res.data
                        this.inputphone = res.data.mobile
                    }
                    if (typeof callback === 'function') {
                        callback()
                    }
                })
                .catch(() => {
                    if (typeof callback === 'function') {
                        callback()
                    }
                })
        },
        sendSmsCode () {
            // sasdk.getfreecode()
            // this.errormsg = ''
            // this.codeerrormsg = ''

            if (this.inputphone) {
                if (!isPhone(this.inputphone, 'CN')) {
                    // this.codeerrormsg = '请输入正确的手机号码'
                    Toast('请输入正确的手机号码')
                    return
                }
            } else {
                Toast('请输入您的手机号')
                return
            }
            if (this.sendingsmscode) {
                return
            }
            this.sendingsmscode = true
            Toast.loading({
                message: '加载中...',
                forbidClick: true
            })
            sendSmsCode(
                {
                    username: this.inputphone,
                    type: 1,
                    appId,
                    function: 'login',
                    channelId,
                    channelKeyword
                },
                this.headers
            )
                .then(res => {
                    this.sendingsmscode = false
                    Toast.clear()
                    if (res.data.code === 0) {
                        this.sendcode = true
                        this.codeTimeout()
                    } else {
                        // this.codeerrormsg = res.data.msg
                        Toast(res.data.msg)
                    }
                })
                .catch(err => {
                    Toast.clear()
                    this.sendingsmscode = false
                    if (err && err.response && err.response.status === 410) {
                        if (this.captchaObj) {
                            this.captchaObj.verify()
                        } else {
                            // 初始化极验组件
                            var headers = err.response.headers
                            var gtinfo = (this.gtinfo = {
                                gt: headers['vk-gt'],
                                challenge: headers['vk-gt-challenge'],
                                initsuccess: headers['vk-gt-initsuccess'],
                                newcaptcha: headers['vk-gt-newcaptcha']
                            })
                            // eslint-disable-next-line no-undef
                            initGeetest(
                                {
                                    // 以下 4 个配置参数为必须，不能缺少
                                    gt: gtinfo.gt,
                                    challenge: gtinfo.challenge,
                                    offline: gtinfo.initsuccess === 'false', // 表示用户后台检测极验服务器是否宕机
                                    new_captcha: gtinfo.newcaptcha === 'true', // 用于宕机时表示是新验证码的宕机

                                    product: 'bind', // 产品形式，包括：float，popup
                                    width: '300px'

                                    // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
                                },
                                captchaObj => {
                                    this.captchaObj = captchaObj
                                    captchaObj
                                        .onReady(() => {
                                            captchaObj.verify()
                                        })
                                        .onSuccess(() => {
                                            const result = captchaObj.getValidate()
                                            this.headers = {
                                                'vk-gt-challenge':
                                                    result.geetest_challenge,
                                                'vk-gt-validate':
                                                    result.geetest_validate,
                                                'vk-gt-seccode':
                                                    result.geetest_seccode,
                                                'vk-gt-type': 2
                                            }
                                            this.sendSmsCode()
                                        })
                                    //
                                }
                            )
                        }
                    } else if (
                        err &&
                        err.response &&
                        err.response.status === 400
                    ) {
                        if (err.response.data && err.response.data.msg) {
                            let msg = ''
                            switch (err.response.data.msg) {
                                case 'VERIFY_CODE_SEC_REPEAT':
                                    msg = '操作太过频繁，请稍后重试！'
                                    break
                                case 'PARAMETER_ERROR':
                                    msg = '请输入正确的手机号码！'
                                    break
                                case 'VERIFY_CODE_SEND_ERROR':
                                    msg = '验证码发送失败，请重试！'
                                    break
                                case 'MOBILE_INVALID':
                                    msg = '请输入正确的手机号码！'
                                    break
                                default:
                                    msg = '验证码发送失败，请重试！'
                                    break
                            }
                            this.codeerrormsg = msg
                            Toast(msg)
                        }
                    }
                })
        },
        codeTimeout () {
            this.timeout = 60
            var current = new Date().getTime()
            clearInterval(timemeter)
            timemeter = setInterval(() => {
                var now = new Date().getTime()
                var timeout = 60 - Math.floor((now - current) / 1000)
                if (timeout < 0) {
                    clearInterval(timemeter)
                } else {
                    this.timeout = timeout
                }
            }, 1000)
        },
        // 点击立即领取
        subCommit () {
            sasdk.getfree()
            // 如果没有默认登录，就去登录
            if (!this.userinfo.mobile) {
                if (this.inputphone) {
                    if (!isPhone(this.inputphone, 'CN')) {
                        // this.codeerrormsg = '请输入正确的手机号码'
                        Toast('请输入正确的手机号码')
                        return
                    }
                } else {
                    Toast('请输入您的手机号')
                    return
                }
                if (!this.inputcode) {
                    // this.codeerrormsg = '请输入正确的验证码'
                    Toast('请输入短信验证码')
                    return
                }
                this.login()
                // 如果登录了，直接同步引流信息
            } else {
                // this.drainageSignUp()
                // this.recordActivation()
                this.doSelectStudent()
            }
        },
        login () {
            // if (!(/^1[34578]\d{9}$/.test(this.inputphone))) {
            //   this.errormsg = '请输入正确的手机号'
            //   return false
            // }
            if (!this.inputcode) {
                // this.codeerrormsg = '请输入短信验证码'
                Toast('请输入短信验证码')
                return false
            }
            Toast.loading({
                message: '加载中...',
                forbidClick: true
            })
            loginByCode({
                username: this.inputphone,
                verifyCode: this.inputcode,
                channelKeyword,
                channelId,
                appId
            })
                .then(res => {
                    if (res.status === 200 && res.data.code === 0) {
                        cookie.set('Authorization', res.data.data.token)
                        this.drainageSignUp()
                            .then(res => {
                                // this.recordActivation()
                                this.doSelectStudent()
                                Toast.clear()
                            })
                            .catch(() => {
                                Toast.clear()
                            })
                    } else {
                        // this.errormsg = res.data.msg
                        Toast(res.data.msg)
                    }
                })
                .catch(err => {
                    Toast.clear()
                    if (err && err.response && err.response.status === 400) {
                        if (err.response.data && err.response.data.msg) {
                            let msg = ''
                            switch (err.response.data.msg) {
                                case 'VERIFY_CODE_SEC_REPEAT':
                                    msg = '操作太过频繁，请稍后重试！'
                                    break
                                case 'PARAMETER_ERROR':
                                    msg = '手机号或验证码错误'
                                    break
                                case 'VERIFY_CODE_ERROR':
                                    msg = '验证码错误'
                                    break
                                case 'VERIFY_CODE_EXPIRED':
                                    msg = '验证码过期'
                                    break
                                default:
                                    msg = '登录异样'
                                    break
                            }
                            this.codeerrormsg = msg
                            Toast(msg)
                        }
                    }
                })
        },
        // uc 记录引流关系
        drainageSignUp () {
            return new Promise(function (resolve, reject) {
                drainageSignUp({
                    appId,
                    channelId,
                    channelKeyword,
                    birthday: new Date()
                })
                    .then(res => {
                        if (res.code === 0) {
                            if (res.data.id) {
                                cookie.set('mathparentid', res.data.id)
                                cookie.set('cookie_id', res.data.id)
                                sasdk.registerPage({
                                    student_id: '',
                                    parent_id: res.data.id
                                })
                            }
                            resolve()
                        } else {
                            reject(res.message)
                        }
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        // 点击领取且登陆后的接口调用
        recordActivation () {
            var parentId = this.getParentID()
            var checkresult = function () {
                if (this.userinfo.hadMathOrder) {
                    this.$router.push('/actouch/fail')
                } else {
                    this.$router.push('/actouch/success')
                }
            }
            recordActivation({
                activityCode,
                channelId,
                parentId,
                grade: this.selectgrade
            })
                .then(res => {
                    // checkresult.call(this)
                })
                .catch(() => {
                    // checkresult.call(this)
                })
            this.getReferrer(() => {
                checkresult.call(this)
            })
        },
        recordStudentActivation (studentId) {
            var parentId = this.getParentID()
            cookie.set('mbstudentid', studentId, {
                domain: gateway.domain
            })

            // 激活与更新信息已拆成 2 个接口
            recordStudentActivation({
                activityCode,
                channelId,
                channelKeyword,
                parentId,
                studentId,
                grade: this.selectgrade
            }).finally(() => {
                updateStudentInfo({
                    studentId,
                    grade: this.selectgrade
                }).finally(() => {
                    getStudentInfo({ studentId })
                        .then(response => {
                            let data = response.data
                            if (response.code !== 200) {
                                Toast('领取失败，请联系客服。')
                                return
                            }
                            if (data.hadMathOrder || data.hadTrialOrder) {
                                this.$router.push('/actouch/fail')
                            } else {
                                location.href = {
                                    3: '//mobile.vipkid.com.cn/shop/spread/sp_59de0e45',
                                    4: '//mobile.vipkid.com.cn/shop/spread/sp_d72eea23',
                                    5: '//mobile.vipkid.com.cn/shop/spread/sp_8f3bd65f'
                                }[this.selectgrade]
                                // this.$router.push('/actouch/success')
                                // 需求要求直接跳转到购课页
                                // http://wiki.vipkid.com.cn/pages/viewpage.action?pageId=213986604
                            }
                        })
                        .catch(e => {
                            console.log(e)
                            // Toast('网络错误，领取失败，请重试。')
                        })
                })
            })
        },
        doSelectStudent () {
            Toast.loading()

            getStudentList({ parentId: this.getParentID() }).then(response => {
                Toast.clear()
                let data = response.data
                this.studentList = data.map(student => {
                    return {
                        id: student.id,
                        avatar: student.avatarUrl,
                        name: student.name
                    }
                })

                if (this.studentList.length > 1) {
                    this.displaySelectStudent = true
                } else {
                    this.recordStudentActivation(this.studentList[0].id)
                }
            })
        },
        swipepre () {
            this.$refs.swipe.prev()
        },
        swipenext () {
            this.$refs.swipe.next()
        },
        toTop () {
            sasdk.clickbottom()
            if (!this.userinfo.mobile) {
                if (this.totopanimation) {
                    clearInterval(this.totopanimation)
                    this.totopanimation = ''
                }
                var top = document.scrollingElement.scrollTop
                this.totopanimation = setInterval(() => {
                    top = Math.floor(top / 5 - 1)
                    document.scrollingElement.scrollTop = top
                    if (top <= 300) {
                        clearInterval(this.totopanimation)
                        this.totopanimation = ''
                    }
                }, 30)
            } else {
                // this.drainageSignUp()
                // this.recordActivation()
                this.doSelectStudent()
            }
        },
        onPageScroll () {
            var top = document.scrollingElement.scrollTop
            this.showbottom = top > winh
            if (this.isplay) {
                if (
                    top > videotop - winh + videoheight + 110 * initw &&
                    top < videotop + videoheight
                ) {
                    // if (this.fixvideo) {
                    //   this.fixvideo = false
                    //   this.$refs.videobox.appendChild(this.$refs.video)
                    //   console.log('movein')
                    // }
                } else {
                    // if (!this.fixvideo) {
                    //   this.fixvideo = true
                    //   this.$refs.videofixed.appendChild(this.$refs.video)
                    //   console.log('moveout')
                    // }
                    this.isplay = false
                    setTimeout(() => {
                        this.$refs.video.pause()
                    })
                }
            }
            scrolltopmax = scrolltopmax > top ? scrolltopmax : top
        },
        videoPause () {
            // this.fixvideo = false
            if (this.isplay) {
                setTimeout(() => {
                    this.isplay = false
                }, 10)
                // setTimeout(() => {
                //   if (!this.isplay) {
                //     this.$refs.videobox.appendChild(this.$refs.video)
                //   }
                // }, 500)
            }
            // console.log('pause', this.isplay)
        },
        videoPlay () {
            this.isplay = true
            if (!hasplay) {
                sasdk.videoplay()
                setTimeout(() => {
                    hasplay = true
                }, 10)
            }
            // console.log('play', this.isplay)
        },
        switchStatus () {
            if (this.isplay) {
                this.$refs.video.pause()
            } else {
                this.$refs.video.play()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/img/actouch/spriteout/sprites.scss';
#app {
    background-color: #2a41b9;
    font-family: 'PingFangSC-Regular';
}
.touch-page {
    min-height: 100vh;
    width: 750px;
    margin: 0 auto;
}
.touch-header {
    background: url(~@/assets/img/actouch/banner.png) no-repeat;
    background-size: 750px 912px;
    width: 750px;
    overflow: hidden;
}
.touch-title {
    @include sprite(logo);
    margin-left: 21px;
}
.touch-form {
    width: 670px;
    padding: 48px;
    margin: 544px auto 20px;
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05),
        0 5px 10px 0 rgba(0, 0, 0, 0.05);
}
.touch-reg-gift {
    @include sprite(gift);
    margin: 42px auto 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
        margin-top: 15px;
        text-indent: 180px;
        font-size: 40px;
        font-weight: bold;
        span {
            color: #ff6422;
        }
    }
}
.touch-phone-c {
    width: 590px;
    height: 96px;
    border: 2px solid #e5e5e5;
    margin: 24px auto 0;
    border-radius: 16px;
    background: white;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.touch-phone-disabled {
    background: #ddd;
}
.touch-phone-icon {
    width: 102px;
    height: 44px;
    line-height: 44px;
    font-size: 36px;
    color: #333;
    text-align: center;
    border-right: 2px solid #e5e5e5;
}
.touch-code-icon {
    // @include sprite(code);
    margin-left: 20px;
}
.touch-phone {
    margin-left: 30px;
    margin-right: 10px;
    font-size: 32px;
    flex: 1;
    color: #404040;
    display: block;
    background: transparent;
    height: 40px;
    line-height: 40px;
}
.touch-code {
    margin-left: 30px;
    margin-right: 10px;
    font-size: 32px;
    flex: 1;
    width: 200px;
    color: #404040;
    display: block;
    height: 40px;
    line-height: 40px;
}
.touch-codetime {
    width: 192px;
    height: 96px;
    line-height: 96px;
    background: #ff6422;
    color: white;
    font-size: 28px;
    text-align: center;
    font-weight: 400;
    border-left: 2px solid #ff6422;
    &.code-disable {
        background: #f2f2f2;
        border-left: 2px solid #e5e5e5;
        color: #d0d0d0;
    }
}
.grade-select-t {
    color: #333;
    font-size: 28px;
    margin: 32px 0 0 40px;
}
.grade-select {
    width: 590px;
    margin: 0px auto 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.grade-select-op {
    margin-top: 22px;
    width: 280px;
    height: 80px;
    line-height: 80px;
    font-size: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px solid #d5d9de;
    border-radius: 16px;
    color: #747d87;
    .grade-select-baby {
        @include sprite(baby);
        margin-right: 16px;
        margin-bottom: 10px;
    }
    .grade-select-boy {
        @include sprite(boy);
        margin-right: 16px;
        margin-bottom: 0px;
    }
    &.grade-select-act {
        color: #ff6422;
        background: #fff3ee;
        border-color: #ff6422;
        .grade-select-baby {
            @include sprite('babyac');
        }
        .grade-select-boy {
            @include sprite('boyac');
        }
    }
}
.grade-warning {
    text-align: center;
    color: #747d87;
    margin-top: 30px;
    font-size: 24px;
}
.touch-button-c {
    // @include sprite(button);
    width: 590px;
    height: 100px;
    background: #d0d0d0;
    margin: 30px auto 0;
    border-radius: 51px;
}
.touch-button-act {
    background: #ff6422;
}
.touch-button {
    background: transparent;
    width: 590px;
    height: 100px;
    color: white;
    font-size: 36px;
    font-weight: bold;
}
.touch-whyvip {
    margin-top: 120px;
    background: url(~@/assets/img/actouch/part_intro.png) no-repeat;
    background-size: 750px 668px;
    width: 750px;
    height: 668px;
}
.touch-partone {
    margin-top: 120px;
    background: url(~@/assets/img/actouch/part1.png) no-repeat;
    background-size: 750px 744px;
    width: 750px;
    height: 744px;
}
.touch-parttwo {
    margin-top: 120px;
    background: url(~@/assets/img/actouch/part2.png) no-repeat;
    background-size: 750px 488px;
    width: 750px;
    height: 488px;
}

.touch-three {
    margin-top: 120px;
    background: url(~@/assets/img/actouch/part3.png) no-repeat;
    background-size: 750px 94px;
    width: 750px;
    padding-top: 94px;
}
.touch-teachers-swipe {
    width: 750px;
    margin: 60px auto 0;
}
.teacher-fu {
    @include sprite(fu);
}
.teacher-bai {
    @include sprite(bai);
}
.teacher-fei {
    @include sprite(fei);
}
.teacher-yue {
    @include sprite(yue);
}
.teacher-xian {
    @include sprite(xian);
}
.touch-partfour {
    margin-top: 120px;
    background: url(~@/assets/img/actouch/part4.png) no-repeat;
    background-size: 750px 446px;
    width: 750px;
    height: 446px;
}
.touch-partfive {
    margin-top: 120px;
    background: url(~@/assets/img/actouch/part5.png) no-repeat;
    background-size: 750px 968px;
    width: 750px;
    height: 968px;
}
.touch-video {
    margin: 37px auto 0;
    width: 670px;
    height: 374px;
    position: relative;
    video {
        width: 670px;
        height: 374px;
    }
    .touch-v-bt {
        position: absolute;
        top: 0;
        left: 0;
        img {
            width: 670px;
            height: 374px;
        }
    }
    .touch-bt {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @include sprite(play);
    }
}

.touch-serve {
    margin-top: 120px;
    background: url(~@/assets/img/actouch/part_serve.png) no-repeat;
    background-size: 750px 596px;
    width: 750px;
    height: 596px;
}

.touch-qa {
    margin-top: 120px;
    margin-bottom: 120px;
    background: url(~@/assets/img/actouch/part_qa.png) no-repeat;
    background-size: 750px 548px;
    width: 750px;
    height: 548px;
}

.touch-footer {
    height: 240px;
    z-index: 10;
}

.touch-footer-c {
    position: fixed;
    bottom: 0;
    width: 750px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 10;
}
.touch-footer-info {
    position: absolute;
    width: 100%;
    height: 110px;
    bottom: 0;
    background: #333333;
    display: flex;
    .touch-footer-bit {
        position: relative;
        flex: 1;
        .touch-footer-bitmap {
            @include sprite(bitmap);
            position: absolute;
            bottom: 0;
            left: 22px;
        }
    }
    .touch-footer-content {
        width: 340px;
        .touch-footer-get {
            margin-top: 12px;
            line-height: 46px;
            font-size: 28px;
            color: white;
        }
        .touch-footer-gift {
            line-height: 46px;
            font-size: 32px;
            color: white;
            font-weight: bold;
            span {
                color: #ff6422;
            }
        }
    }
    .touch-footer-bt {
        width: 188px;
        background: #ff6422;
        color: white;
        line-height: 110px;
        text-align: center;
        font-size: 32px;
        font-weight: bold;
    }
}
</style>

<style scoped>
/* .touch-teachers-swipe >>> .van-swipe__indicator{
    background-color:#DCDCDE;
  } */
.swiper-slide {
    width: 340px;
}

.swiper-slide > div {
    width: 320px;
    margin: 0 auto;
}
</style>
